"function"!=typeof Object.assign&&Object.defineProperty(Object,"assign",{value:function(e,t){"use strict";if(null==e)throw new TypeError("Cannot convert undefined or null to object");for(var n=Object(e),r=1;r<arguments.length;r++){var o=arguments[r];if(null!=o)for(var c in o)Object.prototype.hasOwnProperty.call(o,c)&&(n[c]=o[c])}return n},writable:!0,configurable:!0});


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/lib/polyfills/objectAssign.js
// module id = 1143
// module chunks = 106